module.exports = __webpack_public_path__ + "static/img/fluent-apps-24-regular.98ebb7d3.svg";